import { useQuery } from "@tanstack/react-query";
import { Button, Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { useIntl } from "react-intl";
import { editSVG, trashSVG } from "../../../assets/SVGs/SVGs";
import {
  deleteProductCategory,
  listProductCategories,
} from "../../../network/products";
import { queryKeys } from "../../../services/react-query/queryKeys";
import AntTable from "../../AntTable/AntTable";
import HeadTableProductCategories from "../../GlobalTable/HeadTableProductCategories";
import DeleteModal from "../../common/DeleteModal";
import AddProductCategory from "../../product/addCategory/addCategory";

type Props = {};

const ProductCategories = (props: Props) => {
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [selectedCategoryToDelete, setSelectedCategoryToDelete] = useState<
    number | null
  >(null);
  const [search, setSearch] = useState("");
  const {
    data: listCategories,
    isLoading,
    refetch,
  } = useQuery(
    [queryKeys.listProductCategories, search],
    () => listProductCategories({ search }),
    {
      select: (res) => res?.data,
    }
  );
  const intl = useIntl();

  const columns: ColumnsType<any> = [
    {
      title: (
        <div className=" bg-[#eef0ff] w-full h-full  min-w-[100px]">
          {" "}
          {intl.formatMessage({ id: "categoryName" })}
        </div>
      ),
      dataIndex: "name",
      render: (text: any, record: any) => {
        return (
          <div className="bg-white min-w-[150px] rounded-r-lg text-[#00086D] font-semibold">
            {record?.name}
          </div>
        );
      },
    },
    {
      title: (
        <div className=" bg-[#eef0ff] w-full h-full  min-w-[100px]"> </div>
      ),
    },
    {
      title: (
        <div className=" bg-[#eef0ff] w-full h-full  min-w-[100px]"> </div>
      ),
    },
    {
      title: (
        <div className=" bg-[#eef0ff] w-full h-full  min-w-[100px]"> </div>
      ),
    },
    {
      title: (
        <div className=" bg-[#eef0ff] w-full h-full  min-w-[100px]"> </div>
      ),
    },
    {
      title: (
        <div className=" bg-[#eef0ff] w-full h-full  min-w-[100px]"> </div>
      ),
    },

    {
      title: "",

      render: (text: any, record: any) => (
        <div className="flex gap-2">
          <Button
            type="text"
            htmlType="button"
            // className="bg-white min-w-[150px] rounded-r-lg text-[#00086D] font-semibold"
            onClick={() => {
              setSelectedCategory(record?.id);
            }}
          >
            {editSVG}
          </Button>
          <Button
            type="text"
            htmlType="button"
            // className="bg-white min-w-[150px] rounded-r-lg text-[#00086D] font-semibold"
            onClick={() => {
              setSelectedCategoryToDelete(record?.id);
            }}
          >
            {trashSVG}
          </Button>
        </div>
      ),
    },
  ];
  return (
    <div className=" bg-[#EEF0FF] px-6">
      <h4 className="px-6 pt-8 text-lg font-semibold">
        {intl.formatMessage({ id: "product_categories_title" })}
      </h4>
      <AddProductCategory
        isOpen={!!selectedCategory}
        setCategoryId={() => {}}
        handelModalClose={() => {
          setSelectedCategory(null);
        }}
        categoryId={selectedCategory}
      />

      <DeleteModal
        visible={!!selectedCategoryToDelete}
        onClose={() => {
          setSelectedCategoryToDelete(null);
        }}
        onDelete={deleteProductCategory} // Pass the delete function for "Package"
        data={selectedCategoryToDelete}
        confirmationHeader={intl.formatMessage({
          id: "deleteCategoryConfirmation",
        })}
        confirmationText={intl.formatMessage({
          id: "deleteCategoryConfirmationDesc",
        })}
        queryKey={queryKeys.listProductCategories} // Pass the correct key here
        successMessage={intl.formatMessage({
          id: "categoryDeleted",
        })}
      />
      <HeadTableProductCategories setSearch={setSearch} />
      {isLoading ? (
        <Spin
          className="min-h-[50vh] bg-[#eef0ff] w-full flex items-center justify-center"
          size="large"
          spinning={isLoading}
        />
      ) : (
        <AntTable
          expandRowByClick={false}
          tableColumns={columns}
          tableData={listCategories || []}
          hideArrowExpand
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default ProductCategories;
